/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

/** Custom Hooks */
import useDebounce from "../../../app/customHooks/useDebounce";

/** Common Components */
import MolGrid from "../../../components/grid/MolGrid";
import CardSection from "../../../components/ui/card/CardSection";
import CenterModel from "../../../components/ui/centerModel/CenterModel";

/** Common Services & Data Files */
import SwalAlert from "../../../services/swalService/SwalService";
import ToastService from "../../../services/toastService/ToastService";

/** Configuration Files */
import { projectDomainGridConfig } from "./features/config/ProjectDomain.data";

/** RTK Query */
import { useGetAllProjectDomainsMutation, useDeleteProjectDomainMutation } from "../../../app/services/projectDomainAPI";

import AddEditDomain from "./features/AddEditDomain";

const ProjectDomain = () => {

  const molGridRef = useRef();
  const { confirm } = SwalAlert();
  const [showModal, setShowModal] = useState(false);
  const [selectedDomainId, setSelectedDomainId] = useState(null);

  const [dataSource, setDataSource] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortingString, setSortingString] = useState("");

  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 300);

  //** API Call's */
  const [getAllProjectDomains, {
    isFetching: isListLoading,
    isSuccess: isListSuccess,
    data: listResponse
  },] = useGetAllProjectDomainsMutation();

  const [deleteProjectDomain, {
    isSuccess: isDeleteSuccess,
    isLoading: isDeleteLoading,
    data: isDeletData
  },] = useDeleteProjectDomainMutation();

  const fetchDomains = (pageObject, sorting = "") => {
    const request = {
      pagination: { pageNumber: pageObject.pageNumber, pageSize: pageObject.pageSize },
      filters: { searchText: debouncedSearch },
      sortString: sorting,
    };
    getAllProjectDomains(request);
  };

  //** Use Effects */
  useEffect(() => {
    if (isListSuccess && listResponse) {
      if (listResponse) {
        setDataSource(listResponse.dataSource || []);
      }
      if (listResponse.totalRecord) {
        setTotalRowCount(listResponse.totalRecord);
      }
    }
  }, [isListSuccess, listResponse]);

  useEffect(() => {
    if (isDeleteSuccess && isDeletData) {
      ToastService.success(isDeletData.errorMessage);
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      fetchDomains(currentPageObject, sortingString);
    }
  }, [isDeleteSuccess, isDeletData]);

  useEffect(() => {
    onSuccess();
  }, [debouncedSearch]);

  //** Funcation's */
  const handleModalToggle = () => {
    setSelectedDomainId(null);
    setShowModal(!showModal);
  };

  const onSuccess = () => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      fetchDomains(currentPageObject, sortingString);
    }
  }
  const handleSortingChange = (sorting) => {
    setSortingString(sorting);
    const currentPageObject = molGridRef.current.getCurrentPageObject();
    fetchDomains(currentPageObject, sorting);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page.pageNumber);
    fetchDomains(page, sortingString);
  };

  const onEditAction = (data) => {
    const encryptedDomainId = data.projectDomainId;
    setSelectedDomainId(encryptedDomainId);
    setShowModal(true);
  };

  const handleOnSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to delete this Project Domain?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteProjectDomain(data.projectDomainId);
      }
    });
  };

  //** Action Handler */
  const actionHandler = {
    EDIT: onEditAction,
    DELETE: handleDeleteClick,
  };

  return (
    <div>
      <div className="project-domain-list center-top-space">
        <CardSection
          isContentLoading={isListLoading}
          cardTitle={"Project Domain List"}
          rightButton={true}
          buttonClassName="theme-btn"
          titleButtonClick={handleModalToggle}
          buttonText="Add Project Domain"
          textWithIcon={true}
          iconName="material-symbols:add-rounded"
          fontIcon={true}
          searchInputName="Search by Project Domain"
          searchInput={true}
          handleChange={handleOnSearchChange}
        >
          <div className="table-grid">
            <MolGrid
              ref={molGridRef}
              configuration={projectDomainGridConfig}
              dataSource={dataSource}
              allowPagination={true}
              pagination={{
                totalCount: totalRowCount,
                pageSize: 20,
                currentPage: currentPage,
              }}
              isLoading={isListLoading || isDeleteLoading}
              onActionChange={actionHandler}
              onPageChange={handlePageChange}
              onSorting={handleSortingChange}
            />
          </div>
        </CardSection>
      </div>
      <div>
        {showModal && (
          <CenterModel
            showModal={showModal}
            handleToggleModal={handleModalToggle}
            modalTitle={selectedDomainId ? "Update Project Domain" : "Add Project Domain"}
            modelSizeClass="w-40"
          >
            <div className="row">
              <AddEditDomain
                onClose={handleModalToggle}
                projectDomainId={selectedDomainId}
                onSuccess={onSuccess}
              />
            </div>
          </CenterModel>
        )}
      </div>
    </div>
  );
};

export default ProjectDomain;
